import { APIScope } from "@swivl-mono/types";
import { LayoutHeader, LayoutWithSidebar, PageLayout_TwoCol_Narrow_Wide } from "@swivl-mono/ui";
import { Link, Outlet } from "react-router-dom";

import { ShowIf } from "../../Components/ShowIf/ShowIf";
import { SidebarLink } from "../../Components/SidebarLink/SidebarLink";


export function SettingsView() {


  return (
    <LayoutWithSidebar
      sidebar={
        <div className="flex flex-col">
          <LayoutHeader>
            <h2 className="ml-3">Settings</h2>
          </LayoutHeader>
          <SidebarLink to="/settings/account">My Account</SidebarLink>
          <ShowIf scope={APIScope.ROLES_VIEW}>
            <SidebarLink to="/settings/roles">Roles</SidebarLink>
          </ShowIf>
          <ShowIf scope={APIScope.MEMBERS_GET}>
            <SidebarLink to="/settings/members">Members</SidebarLink>
          </ShowIf>
          <ShowIf scope={APIScope.APPS_EDIT}>
            <SidebarLink to="/settings/apps">Apps</SidebarLink>
          </ShowIf>
          <SidebarLink to="/settings/fms-integrations">FMS Integrations</SidebarLink>
          <ShowIf scope={APIScope.ESCALATIONS_EDIT}>
            <SidebarLink to="/settings/escalations">Escalation Groups</SidebarLink>
          </ShowIf>
          <ShowIf scope={APIScope.ESCALATIONS_EDIT}>
            <SidebarLink to="/settings/escalation-history">Escalation History</SidebarLink>
          </ShowIf>
          <ShowIf scope={APIScope.SEQUENCES_VIEW}>
            <SidebarLink to="/settings/sequences">Sequences</SidebarLink>
          </ShowIf>
          <SidebarLink to="/settings/analytics">Analytics</SidebarLink>
          <ShowIf scope={APIScope.WORKFLOWS_EDIT}>
            <SidebarLink to="/settings/brains">Brains</SidebarLink>
          </ShowIf>
          <ShowIf scope={APIScope.WORKFLOWS_EDIT}>
            <SidebarLink to="/settings/ai-assist">AI Assist</SidebarLink>
          </ShowIf>
          <ShowIf scope={APIScope.WORKFLOWS_VIEW}>
            <SidebarLink to="/workflows">Workflows</SidebarLink>
          </ShowIf>
        </div>
      }
      contentNoPadding={true}
      content={<Outlet />}
    />
  );
  //         <div className="absolute inset-0">

  //             <div className="absolute right-0 top-0 left-96 bottom-0">
  //             <Outlet />
  //             </div>
  //         </div>
  //     )
}
